import {Grid, Stack} from "@mui/material";
import React, {FC} from "react";
import {GridItem} from "@/widget/GridItem/GridItem";
import {checkQueryKey, formatTime} from "@/helper/method";
import {ContactVO, useQueryContact} from "@/service/contact.s";


interface ContactDetailProps {
    id?: number;
}

export const ContactDetail: FC<ContactDetailProps> = ({id}) => {
    const {data: contactData} = useQueryContact({id: id!}, checkQueryKey(id))
    const contact: ContactVO = contactData?.data || {} as ContactVO
    return <Stack direction={'column'} width={'100%'} gap={2}>
        <Grid
            spacing={3}
            container>
            <GridItem title={'姓名'} content={contact?.name}/>
            <GridItem title={'联系电话'} content={contact?.mobile}/>
            <GridItem title={'性别'} content={contact?.gender == 1 && '男' || contact?.gender == 2 && "女" || "未知"}/>
            <GridItem title={'邮箱'} content={contact?.email}/>
            <GridItem title={'职位'} content={contact?.post}/>
        </Grid>
    </Stack>
}